const CONSENT_CONFIGS = {
  pons: {
    src: 'https://cdn.consentmanager.net/delivery/autoblocking/8f23a31bb2a33.js',
    host: 'c.delivery.consentmanager.net',
  },
  'pons-i': {
    src: 'https://cdn.consentmanager.net/delivery/autoblocking/8f23a31bb2a33.js',
    host: 'c.delivery.consentmanager.net',
  },
  kern: {
    src: 'https://cdn.consentmanager.net/delivery/autoblocking/8f23a31bb2a33.js',
    host: 'c.delivery.consentmanager.net',
  },
  default: {
    src: 'https://cdn.consentmanager.net/delivery/autoblocking/ee619dfba243a.js',
    host: 'b.delivery.consentmanager.net',
  },
}

export default defineNuxtPlugin(async () => {
  if (!import.meta.client) return

  const config = useRuntimeConfig()
  const instance = config.public.instanceVendor
  const consentConfig = CONSENT_CONFIGS[instance] ?? CONSENT_CONFIGS.default

  try {
    const existingScript = document.querySelector(
      `script[src="${consentConfig.src}"]`
    )

    if (!existingScript) {
      const script = document.createElement('script')
      script.src = consentConfig.src
      script.type = 'text/javascript'
      script.setAttribute('data-cmp-ab', '1')
      script.setAttribute('data-cmp-host', consentConfig.host)
      script.setAttribute('data-cmp-cdn', 'cdn.consentmanager.net')
      script.setAttribute('data-cmp-codesrc', '0')

      script.onerror = (error) => {
        console.error('❌ Consent Manager script loading error:', error)
      }

      document.head.appendChild(script)
    }
  } catch (error) {
    console.error('❌ Consent Manager initialization error:', error)
  }
})
